// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"19":"127a7839","334":"63b4a497","376":"73f8e58b","706":"7490b941","854":"458906c0","960":"27abff8d"}[chunkId] + ".css";
};